import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Jogeshwaritopunecab() {



const cardData = {
  keyword: " Jogeshwari to Pune Cab Service   ",

headingDescription: "Velocity Cab provides reliable and comfortable Jogeshwari to Pune Cab Service, ensuring a hassle-free travel experience for business trips, airport transfers, family outings, and leisure travel. Travelers can book cabs easily online or via phone, with professional drivers, well-maintained vehicles, and timely pickups. We offer one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With 24/7 customer support, Velocity Cab makes Mumbai to Pune travel convenient, safe, and stress-free.",

topPlaces: [
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Jogeshwari to Pune Cab Service",
description: "Jogeshwari to Pune cab service provides reliable intercity transportation between Jogeshwari (Mumbai) and Pune via the Mumbai–Pune Expressway. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel. Professional drivers offer safe driving, punctual pickup from homes, offices, and stations in Jogeshwari. This service is ideal for business travelers, families, and tourists. Air-conditioned vehicles and spacious seating ensure a comfortable long-distance journey. Online booking allows quick confirmation and transparent pricing."
},
{
name: "Jogeshwari to Pune Taxi Fare Return",
description: "Jogeshwari to Pune taxi fare return service offers round-trip travel convenience for passengers traveling between Jogeshwari and Pune. Travelers can enjoy flexible waiting time, professional drivers, and comfortable vehicles. Ideal for business meetings, family trips, and same-day return journeys. Transparent pricing ensures no hidden charges."
},
{
name: "Jogeshwari to Shivajinagar Pune Cab",
description: "Jogeshwari to Shivajinagar Pune cab service provides direct travel to central Pune locations including Shivajinagar railway station and nearby commercial areas. Comfortable sedans, Ertiga, and Innova vehicles ensure smooth expressway travel. Ideal for office and railway commuters."
},
{
name: "Jogeshwari to Hinjewadi Cab Service",
description: "Jogeshwari to Hinjewadi cab service offers reliable transportation to Pune’s IT hub. Professional drivers ensure safe expressway travel, while comfortable vehicles provide spacious seating and luggage capacity. Ideal for corporate employees and business visits."
},
{
name: "Jogeshwari to Wakad Cab Service",
description: "Jogeshwari to Wakad cab service provides convenient travel to one of Pune’s fastest-growing residential and IT zones. Comfortable vehicles and experienced drivers ensure safe, punctual, and smooth highway journeys."
},
{
name: "Jogeshwari to Kharadi Cab Service",
description: "Jogeshwari to Kharadi cab service offers dependable transportation to Pune’s major IT and commercial hub. Spacious vehicles and professional drivers ensure comfortable long-distance travel for corporate and personal trips."
},
{
name: "Jogeshwari to Baner Cab Service",
description: "Jogeshwari to Baner cab service provides safe and comfortable intercity travel to Pune’s premium residential and IT area. Air-conditioned vehicles ensure a smooth expressway journey for families and professionals."
},
{
name: "Jogeshwari to Pune Station Cab",
description: "Jogeshwari to Pune Station cab service ensures timely and reliable transportation for passengers connecting to trains at Pune railway station. Comfortable vehicles provide enough luggage space for long-distance travelers."
},
{
name: "Jogeshwari to Swargate Cab Service",
description: "Jogeshwari to Swargate cab service offers direct connectivity to Pune’s central bus terminal area. Ideal for travelers continuing their journey within Pune or nearby regions."
},
{
name: "Jogeshwari to Pimpri Chinchwad Cab",
description: "Jogeshwari to Pimpri Chinchwad cab service provides smooth travel to PCMC industrial and residential areas. Comfortable vehicles and experienced drivers ensure safe expressway journeys."
},
{
name: "Jogeshwari to Nigdi Cab Service",
description: "Jogeshwari to Nigdi cab service offers reliable transportation to Pune’s Nigdi area in the PCMC region. Spacious vehicles ensure comfort for families and corporate travelers."
},
{
name: "Jogeshwari to Pune One Way Cab",
description: "Jogeshwari to Pune one way cab service provides economical travel for passengers who need a single-direction trip. Transparent fares and comfortable vehicles make it a convenient option."
},
{
name: "Jogeshwari to Pune Round Trip Cab",
description: "Jogeshwari to Pune round trip cab service offers flexible return travel options with waiting time included. Ideal for business meetings, short trips, and same-day returns."
},
{
name: "Jogeshwari to Pune Innova Cab",
description: "Jogeshwari to Pune Innova cab service provides spacious SUV travel with extra luggage capacity. Suitable for families and group travelers seeking comfort on long highway journeys."
},
{
name: "Jogeshwari to Pune Innova Crysta Rental",
description: "Jogeshwari to Pune Innova Crysta rental service offers premium SUV travel with luxury interiors and smooth ride quality. Ideal for corporate and family long-distance travel."
},
{
name: "Jogeshwari to Pune Airport Cab (via Pune)",
description: "Jogeshwari to Pune airport cab service ensures smooth travel for passengers connecting to Pune International Airport. Professional drivers ensure timely arrivals and stress-free journeys."
},
{
name: "Jogeshwari to Pune Corporate Cab Service",
description: "Jogeshwari to Pune corporate cab service provides reliable transportation for business professionals. Comfortable vehicles and punctual service make it ideal for meetings and office travel."
},
{
name: "Jogeshwari to Pune Family Cab Service",
description: "Jogeshwari to Pune family cab service ensures safe and comfortable travel for families. Spacious vehicles provide enough room for passengers and luggage."
},
{
name: "Jogeshwari to Pune Online Cab Booking",
description: "Jogeshwari to Pune online cab booking service allows passengers to easily reserve taxis through digital platforms. Instant confirmation and transparent pricing ensure hassle-free travel."
},
{
name: "Jogeshwari to Pune Taxi Service",
description: "Jogeshwari to Pune taxi service offers reliable intercity travel with experienced drivers and well-maintained vehicles. Ideal for business, tourism, and personal trips."
}
],

tableData: [
["Jogeshwari to Pune Cab Service","Jogeshwari to Pune Taxi Fare Return"],
["Jogeshwari to Shivajinagar Pune Cab","Jogeshwari to Hinjewadi Cab Service"],
["Jogeshwari to Wakad Cab Service","Jogeshwari to Kharadi Cab Service"],
["Jogeshwari to Baner Cab Service","Jogeshwari to Pune Station Cab"],
["Jogeshwari to Swargate Cab Service","Jogeshwari to Pimpri Chinchwad Cab"],
["Jogeshwari to Nigdi Cab Service","Jogeshwari to Pune One Way Cab"],
["Jogeshwari to Pune Round Trip Cab","Jogeshwari to Innova Cab"],
["Jogeshwari to Pune Innova Crysta Rental","Jogeshwari to Pune Airport Cab"],
["Jogeshwari to Pune Corporate Cab Service","Jogeshwari to Pune Family Cab Service"],
["Jogeshwari to Pune Online Cab Booking","Jogeshwari to Pune Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Easy Jogeshwari to Pune Cab Booking",
    WhyChoosedescription: "Jogeshwari to Pune cab service offers quick and simple booking options through phone and online platforms. Passengers can easily confirm their ride with instant booking confirmation for a hassle-free travel experience."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our Jogeshwari to Pune cab service provides experienced drivers familiar with the Mumbai–Pune Expressway. Their knowledge of routes, traffic conditions, and safe driving ensures a smooth and timely journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Jogeshwari to Pune cab booking comes with clear and transparent pricing. Customers receive complete fare details including toll charges and driver allowance before confirming the ride, ensuring no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Jogeshwari to Pune cab service is available 24/7, making it convenient for early morning departures, late-night travel, business trips, airport transfers, and emergency travel needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles used for Jogeshwari to Pune travel are air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable and relaxing long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Passengers can choose from one-way cab service, round-trip bookings, airport transfers, and customized travel options based on their journey requirements between Jogeshwari and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Jogeshwari to Pune cab service offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for solo travelers, families, and groups."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Jogeshwari to Pune cab service is trusted for its punctual drivers, professional service, and reliable intercity transportation experience across all major routes."
  }
]
};

const faqData = [
  { question: "Do you provide Jogeshwari to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab booking services from Jogeshwari to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Jogeshwari from Pune?", answer: "The road distance between Jogeshwari (Mumbai) and Pune is approximately 150–170 km via the Mumbai–Pune Expressway and usually takes around 3 to 4 hours depending on traffic conditions." },
  { question: "Is Jogeshwari to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel requirements at any time of the day or night." },
  { question: "Which vehicles are available for Jogeshwari to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers for group travel." },
  { question: "Can I book a one-way cab from Jogeshwari to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Jogeshwari and Pune." },
  { question: "Do you provide pickup from Jogeshwari railway station or home?", answer: "Yes, we offer pickup from homes, hotels, offices, and nearby railway stations in Jogeshwari." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided for Jogeshwari to Pune travel are fully air-conditioned for comfortable long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Jogeshwari to Pune cabs online or via phone booking with instant confirmation." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, we provide drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, Pimpri Chinchwad, and other locations." },
  { question: "Are vehicles sanitized and safe?", answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Kadam",
    feedback:
      "Smooth coordination and timely pickup made the Jogeshwari to Pune ride very convenient. The cab was clean and the drive felt relaxed throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Reema Shah",
    feedback:
      "Right from pickup in Jogeshwari, everything was handled efficiently for the Pune trip. The ride quality was good and the overall experience felt safe and comfortable.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Jogeshwari to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Jogeshwari to Pune cab service with professional drivers and affordable fares. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for city-to-city travel, airport transfers, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Jogeshwari to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Jogeshwari to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Jogeshwari to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Jogeshwaritopunecab;